
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Loader2, MousePointer, ExternalLink } from "lucide-react";

interface TopClickedProductsTableProps {
  data: Array<{
    vacationId: number;
    vacationName: string;
    clickCount: number;
    productUrl?: string;
    avgPosition: number;
  }>;
  isLoading: boolean;
  title?: string;
}

export const TopClickedProductsTable = ({ data, isLoading, title = "Top Geklikte Producten" }: TopClickedProductsTableProps) => {
  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <MousePointer className="h-5 w-5" />
            {title}
          </CardTitle>
        </CardHeader>
        <CardContent className="flex items-center justify-center h-64">
          <Loader2 className="h-6 w-6 animate-spin" />
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <MousePointer className="h-5 w-5" />
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent>
        {data.length === 0 ? (
          <div className="text-center py-8 text-muted-foreground">
            Nog geen geklikte producten in deze periode
          </div>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Product</TableHead>
                <TableHead className="text-right">Clicks</TableHead>
                <TableHead className="text-right">Gem. Positie</TableHead>
                <TableHead className="text-center">Link</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {data.map((product, index) => (
                <TableRow key={index}>
                  <TableCell className="font-medium max-w-[200px]">
                    <div className="truncate" title={product.vacationName}>
                      {product.vacationName || `Product ${product.vacationId}`}
                    </div>
                  </TableCell>
                  <TableCell className="text-right">{product.clickCount}</TableCell>
                  <TableCell className="text-right">#{Math.round(product.avgPosition)}</TableCell>
                  <TableCell className="text-center">
                    {product.productUrl ? (
                      <a
                        href={product.productUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center text-blue-600 hover:text-blue-800"
                      >
                        <ExternalLink className="h-4 w-4" />
                      </a>
                    ) : (
                      <span className="text-gray-400">-</span>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
};
